export const sendAnalyticsEvent = (category, action, label) => {
  const analyticsAllowed = window.CookieConsent?.allowedCategory?.('analytics');

  if (window.gtag && analyticsAllowed && label && Object.keys(label).length > 0) {
    gtag('event', action, {
      event_category: category,
      event_label: JSON.stringify(label),
      send_to: process.env.REACT_APP_GA_TAG
    });
  }
};

export const trackPageView = (pageData) => {
  const analyticsAllowed = window.CookieConsent?.allowedCategory?.('analytics');

  if (window.gtag && analyticsAllowed) {
    gtag('event', 'page_view', {
      page_location: pageData.page,
      page_title: document.title,
      ...pageData,
      send_to: process.env.REACT_APP_GA_TAG
    });
  }
};